import styled from '@emotion/styled';
import { Button, Checkbox, Modal, Spin } from 'antd';
import React, { FC, useState } from 'react';
import tw from 'twin.macro';
import { sendNotification } from 'utils/helperMethods';
import Loader from '../Loader';
import { antIcon } from './FilterApplyButton';

interface Props {
    isOpen: boolean;
    loading: boolean;
    setIsOpen: Function;
    onSaveClick: Function;
}
export const CustomButton = styled(Button)`
    &.ant-btn[disabled] {
        ${tw`bg-borderGrey text-promoColour text-[13px] rounded font-bold`}
    }
    &.ant-btn:focus:not(:disabled),
    &.ant-btn:hover:not(:disabled) {
        ${tw`border-purpleFont text-white opacity-80 bg-purpleFont`}
    }
    ${tw`py-2 px-5 rounded h-auto border-purpleFont bg-purpleFont text-white font-bold`}
`;
export const CancelButton = styled(Button)`
    &.ant-btn[disabled] {
        ${tw`bg-borderGrey text-promoColour text-[13px] rounded font-bold`}
    }
    &.ant-btn:focus:not(:disabled),
    &.ant-btn:hover:not(:disabled) {
        ${tw`border-purpleFont text-purpleFont opacity-80`}
    }
    ${tw`py-2 px-5 rounded h-auto border-purpleFont text-purpleFont font-bold`}
`;

function validateTextField(str: string) {
    return str?.trim()?.length > 0;
}

const SaveSelectionPresetsModal: FC<Props> = ({ loading, onSaveClick, isOpen, setIsOpen }) => {
    const [saveSelectionInfo, setSaveSelectionInfo] = useState({ label: '', isDefault: false });

    const closeModal = () => {
        setIsOpen(false);
        setSaveSelectionInfo({ label: '', isDefault: false });
    };
    const onSave = () => {
        if (loading) return;
        const temp = { ...saveSelectionInfo };
        const isValidTextField = validateTextField(temp.label);
        if (isValidTextField) {
            onSaveClick(temp);
            setSaveSelectionInfo({ label: '', isDefault: false });
        } else {
            //show error message
            sendNotification('error', 'Please enter a valid name.');
        }
    };
    return (
        <div>
            <Modal
                bodyStyle={{ padding: 16 }}
                open={isOpen}
                destroyOnClose
                closeIcon={<></>}
                centered
                footer={''}
                width={400}
                onCancel={(e) => closeModal()}
            >
                <p className="font-medium font-md leading-[normal]">Name</p>
                <div className="w-full border border-purpleFont rounded my-2 py-1 px-2">
                    <input
                        value={saveSelectionInfo.label}
                        onChange={(e) => setSaveSelectionInfo({ ...saveSelectionInfo, label: e.target.value })}
                        placeholder="Enter Name"
                        style={{ outline: 'none', border: 'none', width: '100%' }}
                    />
                </div>
                <div className="flex items-center gap-2 mb-4">
                    <Checkbox
                        value={saveSelectionInfo?.isDefault}
                        checked={saveSelectionInfo?.isDefault}
                        onChange={(e) => setSaveSelectionInfo({ ...saveSelectionInfo, isDefault: e.target.checked })}
                    />
                    <p className="text-greyFont font-xs">Make this default</p>
                </div>
                <div className="flex justify-end items-center gap-2">
                    <CancelButton onClick={(e) => closeModal()}>Cancel</CancelButton>
                    <CustomButton onClick={() => onSave()}>
                        {loading ? <Spin indicator={antIcon} /> : 'Save'}
                    </CustomButton>
                </div>
            </Modal>
        </div>
    );
};

export default SaveSelectionPresetsModal;
